import { createContext, FC, ReactNode, useContext, useState } from "react";

import { LocalStorage } from "@/helpers/local-storage";
import { SessionStorage } from "@/helpers/session-storage";

type StorageContextI = {
  localStore: LocalStorage;
  sessionStore: SessionStorage;
};

interface LocalStorageProviderPropsI {
  children?: ReactNode;
}

const StorageContext = createContext<StorageContextI>({} as StorageContextI);

export const useLocalStorage = () => useContext(StorageContext).localStore;
export const useSessionStorage = () => useContext(StorageContext).sessionStore;

/**
 * There is no reason to create instances of LocalStorage / Session every time we
 * need to use it. This context aims to resolve this issue by creating a single
 * instance and sharing as a stable state variable across the app.
 *
 * @param children
 * @constructor
 */
export const StorageProvider: FC<LocalStorageProviderPropsI> = ({
  children,
}) => {
  const [localStore] = useState(new LocalStorage());
  const [sessionStore] = useState(new SessionStorage());

  return (
    <StorageContext.Provider value={{ localStore, sessionStore }}>
      {children}
    </StorageContext.Provider>
  );
};
